import * as THREE from "three";
import Commons from "oc-modules/oc-commons/Commons";
import UniversalLoader from "oc-modules/oc-threejs/loader/UniversalLoader";
import Textures from "oc-modules/oc-threejs/Textures";

export const envMapLoader = (urls: string[], renderer, isRGBM = false, onLoadExtern=()=>{}) => {
    if (Commons.isEmpty(urls) || urls.some(url => Commons.isEmpty(url))) {
        return null;
    }
    const isCube = !Commons.isEmpty(urls[1]);
    const getSuffix = url => url.split(/[?#]/g)[0].substringAfterLast('.');
    const {loadingManager, crossOrigin} = UniversalLoader;
    const onLoad = (texture, isCube, encoding, sourceFile) => {
        texture.anisotropy = Textures.getMaxAnisotropy();
        texture.encoding = encoding;
        texture.mapping = isCube ? THREE.CubeReflectionMapping : THREE.EquirectangularReflectionMapping;
        texture.sourceFile = sourceFile;
        onLoadExtern();
    };
    if (isCube) {
        const suffix = getSuffix(urls[0]);
        if (suffix == 'hdr') {
            const loader = new THREE.HDRCubeTextureLoader(loadingManager);
            loader.setCrossOrigin(crossOrigin);
            loader.setDataType(THREE.UnsignedByteType);
            return loader.load(urls, (cubeMap) => onLoad(cubeMap, true, THREE.sRGBEncoding, urls));
        } else if (isRGBM) {
            const loader = new THREE.RGBMLoader(loadingManager);
            loader.setCrossOrigin(crossOrigin);
            return loader.loadCubemap(urls, (cubeMap) => onLoad(cubeMap, true, THREE.RGBM16Encoding, urls));
        } else {
            const loader = new THREE.CubeTextureLoader(loadingManager);
            loader.setCrossOrigin(crossOrigin);
            return loader.load(urls, (cubeMap) => onLoad(cubeMap, true, THREE.sRGBEncoding, urls));
        }
    } else {
        const url = urls[0];
        let loader: THREE.DataTextureLoader;
        const suffix = getSuffix(url);
        if (suffix == 'exr') {
            loader = new THREE.EXRLoader(loadingManager);
            loader.setDataType(THREE.UnsignedByteType)
        } else if (suffix == 'hdr') {
            loader = new THREE.RGBELoader(loadingManager);
            loader.setDataType(THREE.UnsignedByteType);
        } else if (isRGBM) {
            loader = new THREE.RGBMLoader(loadingManager);
            loader.setDataType(THREE.UnsignedByteType);
        } else {
            loader = new THREE.TextureLoader(loadingManager);
        }
        loader.setCrossOrigin(crossOrigin);
        return loader.load(url, (texture) => onLoad(texture, false, THREE.sRGBEncoding, url));
    }
}
